// Core form-field building blocks + context hook.
export * from './FormField'

// Pre-built field components.
export * from './fields'

// Layout + submit components.
export * from './components'

// Reusable zod validators (password, phone) for react-hook-form schemas.
export * from './validators'

// Re-exports so consumers can import everything from a single path.
export {
  Controller,
  FormProvider,
  FormProvider as GrandFormProvider,
  useForm,
  useFormContext,
  useWatch,
  useFieldArray
} from 'react-hook-form'

export type {
  FieldValues,
  FieldPath,
  UseFormReturn,
  UseFieldArrayReturn,
  SubmitHandler,
  RegisterOptions,
  Resolver
} from 'react-hook-form'

export { zodResolver } from '@hookform/resolvers/zod'
